
import React      from 'react';
import CSSModules from 'react-css-modules';

import { GoogleMapLoader, GoogleMap, Marker } from 'react-google-maps';

import Button           from '../Button';
import FontIcon         from '../FontIcon';
import VenueForm        from '../VenueForm';
import Overlay          from '../Overlay';
import YesNoOptionPanel from '../YesNoOptionPanel';

import * as venueList from '../../actions/venueList';

import { connect } from 'react-redux';

import style from './style.scss';

class VenueList extends React.Component {

    componentDidMount() {

        this.props.refreshVenues();
    }

    _getMapElement(markerPosition) {

        var zoom = 15;

        if (!markerPosition.lat && !markerPosition.lng) {

            markerPosition = null;
            zoom = 5;
        }

        const defaultCenter = {
            lat: 52.456009,
            lng: -1.582031
        };

        const markerSettings = {
            position: markerPosition
        };

        const mapSettings = {
            zoom: zoom,
            center: markerPosition || defaultCenter,
            defaultOptions: {
                mapTypeControl: true,
                streetViewControl: true
            }
        };

        return (
            <GoogleMap { ...mapSettings }>
                <Marker { ...markerSettings } />
            </GoogleMap>
        );
    }

    _getMapContainer() {

        return <div className={ style['map'] }></div>
    }

    _getDeleteVenueOverlayContent() {

        if (this.props.isDeleteVenueOverlayOpen) {

            const { venueToDelete } = this.props;

            return (
                <div>

                    <p>
                        Are you sure you want to to delete the&nbsp;

                        <span styleName="venue-to-delete">
                            { venueToDelete.address.address_1 }
                        </span>

                        &nbsp;venue?
                    </p>

                    <YesNoOptionPanel no={ this.props.hideDeleteVenueOverlay }
                                      yes={ this.props.deleteVenue.bind(this, venueToDelete.id) } />

                </div>
            );
        }
    }

    render() {

        const component = this;

        return (

            <article>

                <Overlay isOpen={ this.props.isDeleteVenueOverlayOpen }
                         closeOverlay={ this.props.hideDeleteVenueOverlay }
                         title="Delete Venue"
                         size="small">

                    { this._getDeleteVenueOverlayContent() }

                </Overlay>

                <Overlay isOpen={ this.props.isEditVenueOverlayOpen }
                         closeOverlay={ this.props.hideEditVenueOverlay }
                         title="Edit Venue"
                         size="medium">

                    <VenueForm submitSuccess={ this.props.updateVenueSuccess }
                               cancel={ this.props.hideEditVenueOverlay } />

                </Overlay>

                <Overlay isOpen={ this.props.isNewVenueOverlayOpen }
                         closeOverlay={ this.props.hideNewVenueOverlay }
                         title="New Venue"
                         size="medium">

                    <VenueForm submitSuccess={ this.props.createVenueSuccess }
                               cancel={ this.props.hideNewVenueOverlay } />

                </Overlay>

                <Button onClick={ this.props.showNewVenueOverlay }
                        className={ style['new-venue-button'] }>

                    <FontIcon textPosition="right" iconName="plus" />
                    <span>New venue</span>

                </Button>

                <section styleName="venues">

                    {
                        this.props.venues.map((venue) => {

                            const position = {
                                lat: parseFloat(venue.address.latitude),
                                lng: parseFloat(venue.address.longitude)
                            };

                            return (

                                <article key={ venue.id } styleName="venue">

                                    <GoogleMapLoader containerElement={ component._getMapContainer() }
                                                     googleMapElement={ component._getMapElement(position) } />

                                    <div styleName="address">

                                        <address>
                                            <span styleName="address-line">{ venue.address.address_1 }</span>
                                            <span styleName="address-line">{ venue.address.address_2 }</span>
                                            <span styleName="address-line">{ venue.address.town_city }</span>
                                            <span styleName="address-line">{ venue.address.post_code }</span>
                                        </address>

                                        <div styleName="address-actions">

                                            <a styleName="address-action"
                                               onClick={ this.props.showEditVenueOverlay.bind(this, venue) }>

                                                Edit
                                            </a>

                                            <a onClick={ this.props.showDeleteVenueOverlay.bind(this, venue) }
                                               styleName="address-action">

                                                Delete
                                            </a>

                                        </div>

                                    </div>

                                </article>
                            );
                        })
                    }

                </section>

            </article>
        );
    }
}

function mapStateToProps(state) {

    return state.venueList;
}

function mapDispatchToProps(dispatch) {

    return {
        createVenueSuccess: () => {

            dispatch(venueList.refreshVenues());
            dispatch(venueList.hideNewVenueOverlay());
        },
        updateVenueSuccess: () => {

            dispatch(venueList.refreshVenues());
            dispatch(venueList.hideEditVenueOverlay());
        },
        hideEditVenueOverlay: () => {

            dispatch(venueList.hideEditVenueOverlay());
        },
        showEditVenueOverlay: (venue) => {

            dispatch(venueList.showEditVenueOverlay(venue));
        },
        deleteVenue: (venueId) => {

            dispatch(venueList.deleteVenue(venueId));
        },
        showDeleteVenueOverlay: (venue) => {

            dispatch(venueList.showDeleteVenueOverlay(venue));
        },
        hideDeleteVenueOverlay: () => {

            dispatch(venueList.hideDeleteVenueOverlay());
        },
        refreshVenues: () => {

            dispatch(venueList.refreshVenues());
        },
        hideNewVenueOverlay: () => {

            dispatch(venueList.hideNewVenueOverlay());
        },
        showNewVenueOverlay: () => {

            dispatch(venueList.showNewVenueOverlay());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(VenueList, style));


// WEBPACK FOOTER //
// ./components/VenueList/index.js